import { render, staticRenderFns } from "./RoundRobinStage.vue?vue&type=template&id=282f289e"
import script from "./RoundRobinStage.vue?vue&type=script&lang=js"
export * from "./RoundRobinStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports